import { DOMAINS } from 'utils/Constants'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

const PRODUCTION_DOMAIN_KEYS = {
  [DOMAINS.CHILD_CARE_ADVANTAGE]: 'wZwOGE7gsVraZER3SDgY5ZVCREEi7QGi',
  [DOMAINS.CANADIAN_NANNY]: 'lZnNGZEA5kNkiNoSfTDhW9H98hsslT2L',
  [DOMAINS.HOUSE_KEEPER]: 'JwduvmoCsbBgEQrdG79t8OPvwTc2ibIS',
  [DOMAINS.HOUSE_SITTER]: 'RssK49b4eilvega8ID4x4YTPlvzchClD',
  [DOMAINS.SITTER]: 'iiGtTzGNouX4CsvBQKrwqBF8AVLjSIMS',
  [DOMAINS.PET_SITTER]: 'SITbPk2tYbV1B8gT0CUuJyGFrOLdo39J',
  [DOMAINS.ELDER_CARE]: 'KJAiZwpju5zvhezSaKAvffCDzmfADzHB',
  [DOMAINS.MOM_TERESA]: 'MixH1XLxSgMA3S397mxn69Ka7Nyk4l1d',
  [DOMAINS.MEET_A_CARPENTER]: '5MLIscyeFAH2dIAEvNV2wXLirLIGo6c9',
  [DOMAINS.MEET_A_GARDENER]: 'sx9eyYZdrhxtpxfiEqN9oul2HLlNJpSy',
  [DOMAINS.MEET_A_LANDSCAPER]: 'QHEP3ORGOIuC2NK7mJhEuZ6PAw9XgVfm',
  [DOMAINS.MEET_AN_ACCOUNTANT]: 'GrTS03SR3MDdu3IwdI6da1YbzKssJ2cZ',
  [DOMAINS.MEET_AN_ENGINNER]: 'P8lPLM62MpMdn21Nx7FSkzC0EQGSdyIN',
  [DOMAINS.MEET_A_CHEF]: 'egXl9MfrZYKa8i54MdS7piKEsESgm0D4',
  [DOMAINS.MEET_A_HANDYMAN]: 'OgfnQ72wjGQEHFelLBxRZivkFQoDVwsY',
  [DOMAINS.MEET_A_MECHANIC]: '9pDIBL6cwW75R7X89x8hGCD7pTswbOWY',
  [DOMAINS.MEET_AN_ELECTRICIAN]: 'dcnXiqaHAcmaLEwLavz8MknKvGrQWHVJ',
  [DOMAINS.MEET_A_PAINTER]: 'xEPVnXa4RhaWBhRUwQd3GwQYZzFlcchF',
  [DOMAINS.MEET_A_PHOTOGRAPHER]: 'K6aJfHqaoakFPkh6sYsgIOyx27CtmvWo',
  [DOMAINS.MEET_A_PROGRAMMER]: 'eQDOeK4Fqxc2GhAS0nqJUBf1YpUjUWya',
  [DOMAINS.MEET_A_ROOFER]: 'UwM0Wf6cYR3FqwVyHyixUEKCrJpl4wxz',
  [DOMAINS.MEET_A_SECURITY_GUARD]: 'e3DUVbVrNkU7DWFm7OIz52OSrS3lQ9Lm',
  [DOMAINS.MEET_A_TUTOR]: 'Kk7fgaPz6rpI0sHSxm2AXRlQO2bnS4mE',
  [DOMAINS.MEET_A_WEB_DEVELOPER]: 'QyPWNDndIfx8mDeseyC1xJRfkCAdZoaW',
  [DOMAINS.MEET_A_PLUMBER]: '3x2mVuvRDnPJcfleRiIQa0IwlAX4I7lz',
  [DOMAINS.MEET_A_RENOVATOR]: 'hcGiF8PLGnTHb8VRFtDiWXmhk5btLEZM',
  [DOMAINS.MEET_A_SALESMAN]: 'yqXMnfnis7zpA79RqSJMBV3Sy96ViYbM',
  [DOMAINS.MEET_A_TRUCK_DRIVER]: 'WE6CKRsy5NMmKW5lbO0mIHcm6KoUGIZr',
  [DOMAINS.MEET_A_VIDEOGRAPHER]: '8piLH20n9xz0Js0FrmSsdrlgErwhXVd4',
  [DOMAINS.MEET_A_WRITER]: 'x4EdmWVk3BToSUxczPQ6wAjbUUQn1RM2',
}

const STAGING_AND_DEVELOPMENT_KEY = 'IZQ1UsNsr98HXWCP9C2paWulaFbyo2n3'

const domainKey = (domain: string) => {
  const { NODE_ENV } = publicRuntimeConfig

  if (NODE_ENV === 'production' && domain) {
    return PRODUCTION_DOMAIN_KEYS[domain]
  }

  return STAGING_AND_DEVELOPMENT_KEY
}

export const getSegmentScript = (domain: string) => {
  return `
  !(function () {
    var analytics = (window.analytics = window.analytics || [])
    if (!analytics.initialize)
      if (analytics.invoked)
        window.console && console.error && console.error('Segment snippet included twice.')
      else {
        analytics.invoked = !0
        analytics.methods = [
          'trackSubmit',
          'trackClick',
          'trackLink',
          'trackForm',
          'pageview',
          'identify',
          'reset',
          'group',
          'track',
          'ready',
          'alias',
          'debug',
          'page',
          'once',
          'off',
          'on',
          'addSourceMiddleware',
          'addIntegrationMiddleware',
          'setAnonymousId',
          'addDestinationMiddleware',
        ]
        analytics.factory = function (e) {
          return function () {
            var t = Array.prototype.slice.call(arguments)
            t.unshift(e)
            analytics.push(t)
            return analytics
          }
        }
        for (var e = 0; e < analytics.methods.length; e++) {
          var key = analytics.methods[e]
          analytics[key] = analytics.factory(key)
        }
        analytics.load = function (key, e) {
          var t = document.createElement('script')
          t.type = 'text/javascript'
          t.async = !0
          t.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'
          var n = document.getElementsByTagName('script')[0]
          n.parentNode.insertBefore(t, n)
          analytics._loadOptions = e
        }
        analytics.SNIPPET_VERSION = '4.13.1'
        analytics.load('${domainKey(domain)}')
      }
  })()`
}

export const onReady = (callback: () => void) => {
  window.analytics.ready(callback)
}

export const pageView = (domain: string, pageName: string) => {
  const properties = { url: document.location.href, path: document.location.pathname, site: domain }
  if (pageName) {
    window.analytics.page(null, pageName, { ...properties, page_type: pageName })
  } else {
    window.analytics.page(null, null, properties)
  }
}

export const trackEvent = (domain: string, eventName: string, metadata: any = {}) => {
  window.analytics.track(eventName, { ...metadata, site: domain })
}

export const identifyUser = (userId?: string, email?: string) => {
  if (userId && email) {
    window.analytics.identify(userId, { email: email })
  }
}

export const group = (id?: string, metadata?: any) => {
  if (!metadata || !id) {
    return
  }

  window.analytics.group(id, metadata)
}
